import { render, staticRenderFns } from "./krasTargetJobRisk.vue?vue&type=template&id=7c3cf3cd"
import script from "./krasTargetJobRisk.vue?vue&type=script&lang=js"
export * from "./krasTargetJobRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c3cf3cd')) {
      api.createRecord('7c3cf3cd', component.options)
    } else {
      api.reload('7c3cf3cd', component.options)
    }
    module.hot.accept("./krasTargetJobRisk.vue?vue&type=template&id=7c3cf3cd", function () {
      api.rerender('7c3cf3cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kras/plan/krasTargetJobRisk.vue"
export default component.exports